import {
  afterRenderEffect,
  Component,
  computed,
  input,
  output,
  viewChild,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { UiText } from '@ory/client';
import { VxIconComponent } from '@ui/icon/icon.component';
import { VxOtpInputComponent } from '@ui/otp-input/otp-input.component';
import { KratosMessagesComponent } from 'src/app/core/components/kratos-messages/kratos-messages.component';
import { CodeStep } from './code-step';

/**
 * The 6-digit code boxes with "Verifying…" or Kratos's messages below, in
 * a fixed-height line so neither pushes what follows. The page owns the
 * `codeStep()` and submits on `completed`.
 */
@Component({
  selector: 'app-code-entry',
  templateUrl: './code-entry.component.html',
  imports: [
    ReactiveFormsModule,
    TranslocoModule,
    KratosMessagesComponent,
    VxIconComponent,
    VxOtpInputComponent,
  ],
  host: { class: 'flex flex-col items-center' },
})
export class CodeEntryComponent {
  readonly step = input.required<CodeStep>();

  /** Off for reasons of the page's own (no flow yet), on top of the step's. */
  readonly disabled = input(false);

  readonly messages = input<UiText[]>([]);

  /** Accessible name of the boxes. Already translated; defaults to "6-digit code". */
  readonly ariaLabel = input<string>();

  readonly completed = output<string>();

  private readonly otp = viewChild(VxOtpInputComponent);

  /** "Verifying…" pauses the input without the disabled look. */
  protected readonly isDisabled = computed(() => {
    const step = this.step();
    return this.disabled() || (step.busy() && !step.verifying());
  });

  constructor() {
    this.initRefocus();
  }

  /** After a wrong code, once "Verifying…" has rendered away. */
  private initRefocus(): void {
    afterRenderEffect(() => {
      if (this.step().refocus() > 0) {
        this.otp()?.focus();
      }
    });
  }
}
